import React from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'


const Container = ({containerOutStyle, containerInStyle, children, adjustHeight}) => {

  const adjustHeightStyle = adjustHeight ?
    {minHeight: window.innerHeight - 35 - 85 - 40 - 10 - 50 - 10 - 80 - 30} : {}

  return (
    <Grid fluid style={{
      ...adjustHeightStyle ,
      paddingLeft:10,paddingRight:10,boxSizing:'border-box',...containerOutStyle,}} >
      <Row center='xs' style={{textAlign:'left'}}>
        <Col xs={12} sm={11} md={9} lg={7} style={containerInStyle}>

          {children}

        </Col>
      </Row>
    </Grid>
  )}


export default Container



// WEBPACK FOOTER //
// ./src/wrapper/Container.jsx